module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/452.6bf006c3.png";